import BaseYAxis from "../../sisu/chart/BaseYAxis.sisu";

const NeoYAxis = BaseYAxis

export default NeoYAxis;